import { Directive, HostListener, inject } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Directive()
export abstract class DialogComponent<T, D = any, R = void> {
  protected readonly dialogRef = inject(MatDialogRef<T, R>);

  dialogSize(): DialogSize {
    return DialogSize.AUTO;
  }

  dialogConfig(): MatDialogConfig<D> {
    const config: MatDialogConfig<D> = {
      width: 'auto',
      maxWidth: '90vw',
      height: 'auto',
      maxHeight: '100vh',
      disableClose: true,
    };

    if (this.dialogSize() == 'small') {
      config.width = '550px';
      config.maxWidth = '550px';
    }

    return config;
  }

  @HostListener('document:keydown.escape')
  protected handleEscape(): void {
    this.close();
  }

  close(request?: R): void {
    this.dialogRef.close(request);
  }
}

export enum DialogSize {
  AUTO = 'auto',
  SMALL = 'small',
}
